// setVersion.js
/**
 * Sets globalThis.VERSION so you can check the app/SW version in the console.
 * Shape:
 *   {
 *     sw: { chunkhash: string },                         // from SW file URL
 *     app: { tag: string, branch: string, sha: string }, // from build env
 *   }
 *
 * Runs right after setBuildEnv.js in index.js (it reads __BUILD_ENV__).
 * chunkhash is 'unknown' when there's no hashed SW filename (dev, or no SSR).
 */
const buildEnv = globalThis.__BUILD_ENV__ || {};
const swUrl = (typeof window !== 'undefined' && window.serviceWorkerPath) || '';
const swChunkhash =
  swUrl.match(/service-worker-legacy\.([^.]+)\.js/)?.[1] || 'unknown';

globalThis.VERSION = {
  sw: { chunkhash: swChunkhash },
  app: {
    tag: buildEnv.TAG_NAME,
    branch: buildEnv.BRANCH_NAME,
    sha: buildEnv.SHORT_SHA,
  },
};
